import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CardProvider } from '@egovsolutions/angular-payment-types';

@Component({
    selector: 'app-payment-method-list-item-card-icon',
    template: `
        <app-card-logo *ngIf="cardProvider === 'amex'" color="currentColor" height="16em / 14" card="amex"></app-card-logo>
        <app-card-logo *ngIf="cardProvider === 'discover'" color="currentColor" height="10em / 14" card="discover"></app-card-logo>
        <app-card-logo *ngIf="cardProvider === 'mastercard'" color="currentColor" height="28em / 14" card="mastercard"></app-card-logo>
        <app-card-logo *ngIf="cardProvider === 'visa'" color="currentColor" height="16em / 14" card="visa"></app-card-logo>
        <app-card-logo *ngIf="cardProvider === 'other'" color="currentColor" height="23em / 14" class="other"></app-card-logo>
    `,
    styleUrls: ['./payment-method-list-item-card-icon.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaymentMethodListItemCardIconComponent
{
    @Input() protected cardProvider: CardProvider = CardProvider.Other;
}
